import { assign,setup } from 'xstate';

export const machine = setup({
  types: {
    context: {} as {
      selectedList: null | number,
      deletingListId: null | number,
      deletingKeywordId: null | number,
      draggingKeyword: string | null,
    },
    events: {} as
      | { type: "list" }
      | { type: "select", listId: number }
      | { type: "create" }
      | { type: "attempt_create" }
      | { type: "attempt_delete_keyword", listId: number, keywordId: number }
      | { type: "attempt_delete_list", listId: number }
      | { type: "cancel" }
      | { type: "reset" }
      | { type: "start_dragging", keyword: string }
      | { type: "end_dragging" }
      | { type: "confirm" },
  },
  actions: {},
  guards: {
    isSameSelectedList: ({ context, event }) => {
      if (event.type === 'select')
        return context.selectedList === event.listId;
    },
    isNotSameSelectedList: ({ context, event }) => {
      if (event.type === 'select')
        return context.selectedList !== event.listId;
    },
  },
}).createMachine({
  context: {
    selectedList: null,
    deletingListId: null,
    deletingKeywordId: null,
    draggingKeyword: null,
  },
  id: "listing-modal",
  initial: "LISTING",
  on: {
    start_dragging: {
      actions: assign({ draggingKeyword: ({ event }) => event.keyword }),
    },
    end_dragging: {
      actions: assign({ draggingKeyword: null }),
    },
  },
  states: {
    LISTING: {
      initial: "UNSELECTED",
      entry: assign({
        selectedList: null,
        deletingListId: null,
        deletingKeywordId: null,
      }),
      on: {
        attempt_create: {
          target: "CREATING",
        },
        reset: {
          target: "LISTING",
          actions: assign({
            selectedList: null,
            deletingListId: null,
            deletingKeywordId: null,
          }),
        },
      },
      states: {
        UNSELECTED: {
          on: {
            select: {
              target: "SELECTED",
              actions: assign({ selectedList: ({ event }) => event.listId }),
            },
          },
        },
        SELECTED: {
          initial: "IDDLE",
          on: {
            select: [
              {
                target: "UNSELECTED",
                guard: {
                  type: 'isSameSelectedList',
                },
                actions: assign({ selectedList: null }),
              },
              {
                target: "SELECTED",
                guard: {
                  type: 'isNotSameSelectedList',
                },
                actions: assign({ selectedList: ({ event }) => event.listId }),
              },
            ],
          },
          states: {
            IDDLE: {
              on: {
                attempt_delete_keyword: {
                  target: "DELETING_KEYWORD",
                  actions: assign({
                    deletingKeywordId: ({ event }) => event.keywordId,
                    deletingListId: ({ event }) => event.listId,
                  }),
                },
                attempt_delete_list: {
                  target: "DELETING_LIST",
                  actions: assign({
                    deletingKeywordId: null,
                    deletingListId: ({ event }) => event.listId,
                  }),
                },
              },
              entry: assign({
                deletingListId: null,
                deletingKeywordId: null,
              }),
            },
            DELETING_KEYWORD: {
              on: {
                cancel: {
                  target: "IDDLE",
                },
                confirm: {
                  target: "IDDLE",
                },
              },
            },
            DELETING_LIST: {
              on: {
                cancel: {
                  target: "IDDLE",
                },
                confirm: {
                  target: "#listing-modal.LISTING.UNSELECTED",
                  actions: assign({
                    selectedList: null,
                    deletingListId: null,
                    deletingKeywordId: null,
                  }),
                },
              },
            },
          },
        },
      },
    },
    CREATING: {
      on: {
        list: {
          target: "LISTING",
        },
        create: {
          target: "#listing-modal.LISTING.UNSELECTED",
        },
        reset: {
          target: "LISTING",
        },
      },
    },
  },
});

export default machine;
